export default __webpack_public_path__ + "static/media/shape2.9ca47b8b.svg";